import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Sunrise, Utensils, Apple, Gift, CheckCircle2 } from 'lucide-react';
export function ContentBreakdown() {
  const scrollToOffer = () => {
    const offerSection = document.getElementById('oferta');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="py-16 px-4 bg-[#FDFBF7]" data-id="element-166">
      <div className="max-w-lg md:max-w-4xl mx-auto" data-id="element-167">
        <div className="text-center mb-12" data-id="element-168">
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-4" data-id="element-169">
            QUÉ INCLUYE NUTRIPEQUES
          </h2>
          <div className="w-24 h-1 bg-[#4CAF50] mx-auto rounded-full" data-id="element-170"></div>
        </div>

        {/* Part 1 */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="mb-16" data-id="element-171">
          <div className="flex items-center gap-3 mb-6" data-id="element-172">
            <div className="bg-[#E8F5E9] p-3 rounded-xl" data-id="element-173">
              <BookOpen className="w-6 h-6 text-[#2E7D32]" data-id="element-174" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900" data-id="element-175">
              PARTE 1: Fundamentos y Herramientas
            </h3>
          </div>

          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-176">
            <div className="divide-y divide-gray-100" data-id="element-177">
              {[{
              title: 'La verdad sobre la alimentación infantil',
              desc: "Qué es realmente 'alimentar bien' (y qué no lo es)"
            }, {
              title: 'Principios básicos de nutrición',
              desc: 'Los 4 pilares esenciales sin tecnicismos'
            }, {
              title: 'Cómo armar un plato equilibrado',
              desc: 'Una herramienta visual, simple y repetible'
            }, {
              title: 'Cómo lograr que coman sin peleas',
              desc: 'Psicología del rechazo + estrategias que funcionan'
            }, {
              title: 'Herramientas que facilitan la rutina',
              desc: 'Sistemas reales para días reales'
            }, {
              title: 'El Sistema NutriKids',
              desc: 'El método de planificación semanal en 30 minutos'
            }].map((item, idx) => <div key={idx} className="p-4 md:p-6 flex flex-col md:flex-row md:items-center gap-2 md:gap-6 hover:bg-gray-50 transition-colors" data-id="element-178">
                  <div className="font-bold text-gray-900 md:w-1/2" data-id="element-179">
                    {item.title}
                  </div>
                  <div className="text-gray-600 md:w-1/2" data-id="element-180">{item.desc}</div>
                </div>)}
            </div>
          </div>
        </motion.div>

        {/* Part 2 */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-181">
          <div className="flex items-center gap-3 mb-8" data-id="element-182">
            <div className="bg-[#FFF3E0] p-3 rounded-xl" data-id="element-183">
              <Utensils className="w-6 h-6 text-[#E65100]" data-id="element-184" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900" data-id="element-185">
              PARTE 2: Recetario Completo — 60 Recetas
            </h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-186">
            {/* Mañanas */}
            <div className="bg-[#FFF9C4]/30 rounded-3xl p-6 border border-[#FFF59D]" data-id="element-187">
              <div className="flex items-center gap-3 mb-4" data-id="element-188">
                <Sunrise className="w-8 h-8 text-[#F57F17]" data-id="element-189" />
                <h4 className="text-xl font-bold text-gray-900" data-id="element-190">
                  MAÑANAS CON ENERGÍA
                </h4>
              </div>
              <p className="text-sm font-bold text-[#F57F17] mb-3" data-id="element-191">
                16 desayunos nutritivos y fáciles
              </p>
              <p className="text-gray-600 text-sm mb-4 italic" data-id="element-192">
                Desayunos sin azúcar añadida, con proteína, fibra y
                carbohidratos reales. Para que la mañana no sea un caos.
              </p>
              <ul className="space-y-2 text-sm text-gray-700" data-id="element-193">
                <li data-id="element-194">• Pancakes de banana y avena</li>
                <li data-id="element-195">• Muffins de manzana y canela</li>
                <li data-id="element-196">• Waffles de batata y avena</li>
                <li data-id="element-197">• Tortitas de lenteja y zanahoria</li>
                <li data-id="element-198">• Smoothie de durazno y yogur</li>
                <li data-id="element-199">• Avena cremosa, pudding de chía y más</li>
              </ul>
            </div>

            {/* Platos */}
            <div className="bg-[#E8F5E9]/50 rounded-3xl p-6 border border-[#C8E6C9]" data-id="element-200">
              <div className="flex items-center gap-3 mb-4" data-id="element-201">
                <Utensils className="w-8 h-8 text-[#2E7D32]" data-id="element-202" />
                <h4 className="text-xl font-bold text-gray-900" data-id="element-203">
                  PLATOS QUE NUTREN
                </h4>
              </div>
              <p className="text-sm font-bold text-[#2E7D32] mb-3" data-id="element-204">
                22 comidas completas y equilibradas
              </p>
              <p className="text-gray-600 text-sm mb-4 italic" data-id="element-205">
                Almuerzos y cenas que combinan proteína, vegetales y energía en
                formatos que los niños realmente aceptan.
              </p>
              <ul className="space-y-2 text-sm text-gray-700" data-id="element-206">
                <li data-id="element-207">• Pastel de pollo y verduras cremoso</li>
                <li data-id="element-208">• Ñoquis caseros de calabaza</li>
                <li data-id="element-209">• Mac & Cheese versión saludable</li>
                <li data-id="element-210">• Nuggets de pescado al horno</li>
                <li data-id="element-211">• Pizzetas con base de pollo o coliflor</li>
                <li data-id="element-212">• Lasaña de verduras, wraps integrales y más</li>
              </ul>
            </div>

            {/* Snacks */}
            <div className="bg-[#FFEBEE]/50 rounded-3xl p-6 border border-[#FFCDD2]" data-id="element-213">
              <div className="flex items-center gap-3 mb-4" data-id="element-214">
                <Apple className="w-8 h-8 text-[#C62828]" data-id="element-215" />
                <h4 className="text-xl font-bold text-gray-900" data-id="element-216">
                  SNACKS INTELIGENTES
                </h4>
              </div>
              <p className="text-sm font-bold text-[#C62828] mb-3" data-id="element-217">
                12 meriendas reales y prácticas
              </p>
              <p className="text-gray-600 text-sm mb-4 italic" data-id="element-218">
                Para resolver loncheras y meriendas sin ultraprocesados ni
                culpa.
              </p>
              <ul className="space-y-2 text-sm text-gray-700" data-id="element-219">
                <li data-id="element-220">• Barritas de cereal caseras</li>
                <li data-id="element-221">• Trufas energéticas de cacao y avena</li>
                <li data-id="element-222">• Bocaditos de lentejas</li>
                <li data-id="element-223">• Crackers de queso</li>
                <li data-id="element-224">• Bastones asados con dip cremoso y más</li>
              </ul>
            </div>

            {/* Gustitos */}
            <div className="bg-[#F3E5F5]/50 rounded-3xl p-6 border border-[#E1BEE7]" data-id="element-225">
              <div className="flex items-center gap-3 mb-4" data-id="element-226">
                <Gift className="w-8 h-8 text-[#6A1B9A]" data-id="element-227" />
                <h4 className="text-xl font-bold text-gray-900" data-id="element-228">
                  GUSTITOS CONSCIENTES
                </h4>
              </div>
              <p className="text-sm font-bold text-[#6A1B9A] mb-3" data-id="element-229">
                10 recetas especiales sin culpa
              </p>
              <p className="text-gray-600 text-sm mb-4 italic" data-id="element-230">
                Porque prohibir no educa. Ofrecer mejor, sí.
              </p>
              <ul className="space-y-2 text-sm text-gray-700" data-id="element-231">
                <li data-id="element-232">• Brownie de banana y cacao</li>
                <li data-id="element-233">• Gomitas naturales de frutas y verduras</li>
                <li data-id="element-234">• Paletas de banana bañadas en chocolate</li>
                <li data-id="element-235">• "Oreos" saludables sin cocción</li>
                <li data-id="element-236">• Malvadiscos naturales y más</li>
              </ul>
            </div>
          </div>

          {/* Cada receta incluye */}
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 md:p-8" data-id="element-237">
            <h4 className="text-xl font-bold text-gray-900 mb-6 text-center" data-id="element-238">
              CADA RECETA INCLUYE:
            </h4>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-239">
              {[{
              icon: '⏱️',
              title: 'Tiempo',
              desc: 'Para saber antes de empezar'
            }, {
              icon: '🍽️',
              title: 'Porciones',
              desc: 'Adaptado a porciones infantiles'
            }, {
              icon: '👶',
              title: 'Edad',
              desc: 'Desde 1 año en adelante'
            }, {
              icon: '💚',
              title: 'Beneficio',
              desc: 'Simple, claro, sin tecnicismos'
            }, {
              icon: '💡',
              title: 'Tips',
              desc: 'Versiones para congelador, variantes, trucos'
            }].map((item, idx) => <div key={idx} className="flex items-start gap-3 p-3 bg-gray-50 rounded-xl" data-id="element-240">
                  <span className="text-2xl" data-id="element-241">{item.icon}</span>
                  <div data-id="element-242">
                    <div className="font-bold text-gray-900 text-sm" data-id="element-243">
                      {item.title}
                    </div>
                    <div className="text-xs text-gray-600" data-id="element-244">{item.desc}</div>
                  </div>
                </div>)}
            </div>
          </div>
        </motion.div>

        <div className="mt-12 flex justify-center" data-id="element-245">
          <button onClick={scrollToOffer} className="w-full max-w-md min-h-[64px] bg-[#2E7D32] hover:bg-[#1B5E20] text-white text-lg md:text-xl font-bold rounded-2xl shadow-[0_6px_0_#1B5E20] hover:shadow-[0_3px_0_#1B5E20] hover:translate-y-1 transition-all px-6 py-4" data-id="element-246">
            → Quiero acceder al recetario
          </button>
        </div>
      </div>
    </section>;
}